var render = function render(){var _vm=this,_c=_vm._self._c;return _c('cube-scroll',{ref:"contentScroll",attrs:{"data":_vm.data,"options":_vm.options},on:{"pulling-down":_vm.onPullingDown,"pulling-up":_vm.onPullingUp}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }